import React from 'react';
import './Hr.scss'

export const Hr = () => {
  return (
    <div className="Hr" />
  )
}